import { render, staticRenderFns } from "./InvoiceInventory.vue?vue&type=template&id=287f6664&scoped=true&"
import script from "./InvoiceInventory.vue?vue&type=script&lang=js&"
export * from "./InvoiceInventory.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceInventory.vue?vue&type=style&index=0&id=287f6664&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287f6664",
  null
  
)

export default component.exports